<template>
  <nav>
    <a href="#" class="nav-brand" :class="{ active: activeSection === 'home' }" @click.prevent="goHome">
      <span><img src="favicon.ico" alt=""> Aeonsoft</span>
    </a>
    <span class="nav-separator" aria-hidden="true"></span>
    <a href="#sobre" :class="{ active: activeSection === 'sobre' }" @click.prevent="goToSection('sobre')">Sobre</a>
    <a href="#produtos" :class="{ active: activeSection === 'produtos' }" @click.prevent="goToSection('produtos')">Produtos</a>
    <a href="#servicos" :class="{ active: activeSection === 'servicos' }" @click.prevent="goToSection('servicos')">Serviços</a>
  </nav>
  <router-view />
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      activeSection: 'home',
      isNavigating: false,
      navigationTimer: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.updateActiveSection()
      window.setTimeout(this.updateActiveSection, 250)
    })
    window.addEventListener('scroll', this.updateActiveSection, { passive: true })
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.updateActiveSection)
    window.clearTimeout(this.navigationTimer)
  },
  methods: {
    goHome() {
      this.activeSection = 'home'
      this.isNavigating = true
      window.scrollTo({ top: 0, behavior: 'smooth' })
      if (window.location.hash) {
        history.pushState('', document.title, window.location.pathname + window.location.search)
      }
      window.clearTimeout(this.navigationTimer)
      this.navigationTimer = window.setTimeout(() => {
        this.isNavigating = false
        this.activeSection = 'home'
      }, 700)
    },
    goToSection(section) {
      const element = document.getElementById(section)
      if (!element) return

      this.activeSection = section
      this.isNavigating = true
      history.pushState('', document.title, `${window.location.pathname}${window.location.search}#${section}`)
      element.scrollIntoView({ behavior: 'smooth', block: 'start' })
      window.clearTimeout(this.navigationTimer)
      this.navigationTimer = window.setTimeout(() => {
        this.isNavigating = false
        this.activeSection = section
      }, 850)
    },
    updateActiveSection() {
      if (this.isNavigating) return

      const sections = ['sobre', 'produtos', 'servicos']
      if (window.scrollY < 220) {
        this.activeSection = 'home'
        return
      }

      const currentPosition = window.scrollY + 110
      let active = ''

      sections.forEach((id) => {
        const element = document.getElementById(id)
        if (element && element.offsetTop <= currentPosition) {
          active = id
        }
      })

      this.activeSection = active || 'home'
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;  
  color: var(--text-color);
  min-width: 100%;

  border: 0px solid red;
}

nav {
  padding: .7rem;
  left: 50%;
  transform: translate(-50%, 0);
  position: fixed;
  display: inline-flex;
  align-items: center;
  gap: .9rem;
  top: 0rem;
  padding-top: 1rem;
  margin: 0 auto;
  z-index: 10;
  color: var(--brand-blue);
  background-color: rgba(2, 2, 19, .92);
  border-top: none;
  border-radius: 0 0 .5rem .5rem;
  box-shadow: 0 .7rem 2rem rgba(0, 0, 0, .22);
  backdrop-filter: blur(10px);
  white-space: nowrap;
  opacity: 0;
  animation: navReveal .8s cubic-bezier(.2, .8, .2, 1) 1.15s forwards;
}

nav a {
  color: white;
  font-weight: 500;
  text-decoration: none;
  opacity: .58;
  transition: opacity .2s ease, color .2s ease;

  &:hover {
    opacity: .86;
  }
}

nav a.router-link-exact-active,
nav a.active {
  font-weight: bold;
  opacity: 1;
}

nav .nav-brand.active {
  opacity: 1;
}

.nav-separator {
  width: 1px;
  height: 1.15rem;
  background: rgba(255, 255, 255, .28);
}

.nav-brand {
  font-weight: bold;

  span {
    display: inline-flex;
    align-items: center;
  }

  img {
    height: 1rem;
    margin-right: .3rem;
  }
}

@media screen and (max-width: 560px) {
  nav {
    width: calc(100% - 1.5rem);
    justify-content: center;
    gap: .65rem;
    font-size: .85rem;
  }
}

@keyframes navReveal {
  from {
    opacity: 0;
    transform: translate(-50%, -.75rem);
    filter: blur(8px);
  }

  to {
    opacity: 1;
    transform: translate(-50%, 0);
    filter: blur(0);
  }
}
</style>
